/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_New_Version_ReloadInputs */

const da_app_new_version_reload = /** @type {(inputs: App_New_Version_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genindlæs`)
};

/** @type {(inputs: App_New_Version_ReloadInputs) => LocalizedString} */
const en_app_new_version_reload = da_app_new_version_reload;

/**

* @param {App_New_Version_ReloadInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const app_new_version_reload = /** @type {((inputs?: App_New_Version_ReloadInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_New_Version_ReloadInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_new_version_reload(inputs)
	return /** @type {LocalizedString} */ ("Genindlæs")
});